import {Component, OnInit, HostListener} from '@angular/core';
import {FormGroup, FormControl, FormBuilder, Validators} from '@angular/forms';
import {ModalService} from '../../../service/modal.service';
import {GlobalService} from '../../../service/global.service';
import {CatalogoApiService} from '../../../service/api/catalogo.api';
import {Router, ActivatedRoute} from '@angular/router';
import {Layout, HeaderLayout} from '../../../model/catalogo';
import {Subscription} from 'rxjs/Subscription';
import {DetalhamentoApiService} from '../../../service/api/detalhamento.api';

@Component({
    selector: 'cadastro-layout-arquivo',
    templateUrl: './cadastro-layout-arquivo.component.html',
    styleUrls: ['./cadastro-layout-arquivo.component.css']
})
export class CadastroLayoutArquivoComponent {
    modoEdicao: Boolean = false;
    paramsSubscription: Subscription = null;
    submitted: boolean = false;
    nome = new FormControl('', [Validators.required]);
    descricao = new FormControl('', [Validators.required]);
    tipoEdicao: String;
    qtdMaxPosicoesPorRegistro = new FormControl('', []);
    posicaoInicial = new FormControl('', []);
    posicaoFinal = new FormControl('', []);
    conteudo = new FormControl('', [Validators.required]);

    layoutForm: FormGroup = this.formBuilder.group({
        nome: this.nome,
        descricao: this.descricao,
    });

    headerForm: FormGroup = this.formBuilder.group({
        posicaoInicial: this.posicaoInicial,
        posicaoFinal: this.posicaoFinal,
        conteudo: this.conteudo
    });

    constructor(private globalService: GlobalService, private router: Router, private route: ActivatedRoute, public modalService: ModalService, private formBuilder: FormBuilder, private catalogoService: CatalogoApiService, public detalhamentoApiService: DetalhamentoApiService) {
    }

    @HostListener('window:keyup', ['$event'])
    keyEvent(event: KeyboardEvent) {
        if (event != null) {
            if (event.keyCode === 13 && this.layoutForm.valid) {
                this.salvarLayout();
            } else {
            }
        }
    }

    novoLayout: Layout = new Layout();
    novoHeader: HeaderLayout = new HeaderLayout();
    listaHeaders: Array<HeaderLayout> = new Array<HeaderLayout>();


    ngOnInit() {
        this.paramsSubscription = this.route.params.subscribe(params => {
            if (params['codigo'] != undefined) {
                this.modoEdicao = true;
                this.novoLayout.codigo = params['codigo'];
                this.novoLayout.versao = params['versao'];
                this.getDadosLayout(params['codigo'], params['versao']);
            }
        });
    }


    ngOnDestroy() {
        if (this.paramsSubscription != null) {
            this.paramsSubscription.unsubscribe();
        }
    }

    numberOnly(event): boolean {
        const charCode = (event.which) ? event.which : event.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            return false;
        }
        return true;
    }

    verificaTamanhoCampo() {
        let tam = 0;
        if (this.headerForm.value.posicaoInicial != '' && this.headerForm.value.posicaoFinal != '') {
            tam = this.headerForm.value.posicaoFinal - this.headerForm.value.posicaoInicial + 1;
            let conteudo: string = this.headerForm.value.conteudo;
            if (conteudo.length > tam) {
                this.modalService.exibirMensagem('Atenção', 'O campo conteúdo não pode ter mais que ' + tam + ' caracteres.', 'Fechar');
                this.conteudo.setValue(conteudo.substring(0, tam));
            }
        } else {
            this.modalService.exibirMensagem('Atenção', 'Informe a posição inicial e final do campo.', 'Fechar');
            this.conteudo.setValue('');
        }
    }

    getDadosLayout(codigo: number, versao: number) {
        this.detalhamentoApiService.detalhaLayout(codigo, versao)
            .subscribe(
                response => {
                    this.nome.setValue(response.nome.trim());
                    this.qtdMaxPosicoesPorRegistro.setValue(response.qtdMaxPosicoesPorRegistro);
                    this.descricao.setValue(response.descricao.trim());
                    this.listaHeaders = [];
                    this.listaHeaders = response.header;
                },
                erro => {
                });
    }

    salvarInstalacaoModal() {
        var msgLayoutArquivo: string = 'Por padrão, a alteração é gravada nesta mesma versão do layout de arquivo. Se optar por gravar em uma nova versão, os FTAs que atualmente apontam para esta instalação vão manter uso dos parâmetros e definições da versão antiga. Deseja manter a mesma versão vigente ?';

        if (this.modoEdicao) {
            this.modalService.abrirPaginaModal('edicao-artefatos-modal', {}, {
                    'pesquisar': false,
                    'mensagem': msgLayoutArquivo
                },
                'Confirmação !', 'Fechar')
                .subscribe(res => {
                    if (res.tipoEdicao) {
                        this.tipoEdicao = 'editar';
                    } else {
                        this.tipoEdicao = 'nova';
                    }
                    this.salvarLayout();
                });
        } else {
            this.salvarLayout();
        }
    }

    salvarLayout() {
        this.novoLayout.nome = this.layoutForm.value.nome;
        this.novoLayout.descricao = this.layoutForm.value.descricao;
        this.novoLayout.qtdMaxPosicoesPorRegistro = parseInt(this.qtdMaxPosicoesPorRegistro.value);
        this.novoLayout.header = [];
        this.novoLayout.header = this.listaHeaders;


        if (this.modoEdicao && this.tipoEdicao == 'nova') {
            this.novoLayout.versao = 0;
        } else if (!this.modoEdicao) {
            this.novoLayout.codigo = 0;
            this.novoLayout.versao = 0;
        }

        this.catalogoService.criaEditaLayout(this.novoLayout.codigo, this.novoLayout.versao, this.novoLayout)
            .subscribe(
                resposta => {
                    this.modalService.exibirMensagem('Layout de Arquivo', 'Layout de Arquivo cadastrado com sucesso!', 'Fechar');
                    this.voltar();
                },
                erro => {
                    if (erro.error) {
                        if (erro.status == 400) {
                            this.modalService.exibirMensagem('Layout de Arquivo', `Erro ao cadastrar layout.<br />${erro.error.mensagem}`, 'Fechar');
                        } else if (erro.status == 401) {
                            this.modalService.exibirMensagem('Layout de Arquivo', `Erro ao cadastrar layout.<br />${erro.error.mensagem}`, 'Fechar');
                        } else if (erro.status == 403) {
                            this.modalService.exibirMensagem('Layout de Arquivo', `Erro ao cadastrar layout.<br />${erro.error.mensagem}`, 'Fechar');
                        } else if (erro.status == 409) {
                            this.modalService.exibirMensagem('Layout de Arquivo', `Erro ao cadastrar layout.<br />${erro.error.mensagem}`, 'Fechar');
                        } else {
                            this.modalService.exibirMensagem('Layout de Arquivo', `Erro ao cadastrar layout.<br />${erro.error.mensagem}`, 'Fechar');
                        }
                    }
                }
            );
    }

    addHeader() {
        this.novoHeader.posicaoInicial = this.headerForm.value.posicaoInicial;
        this.novoHeader.posicaoFinal = this.headerForm.value.posicaoFinal;
        this.novoHeader.conteudo = this.headerForm.value.conteudo;
        this.listaHeaders.push(this.novoHeader);
        this.novoHeader = new HeaderLayout();
        this.headerForm.controls['posicaoInicial'].reset();
        this.headerForm.controls['posicaoFinal'].reset();
        this.headerForm.controls['conteudo'].reset();
    }

    removerHeader(indice: number) {
        this.listaHeaders.splice(indice, 1);
    }

    voltar() {
        this.router.navigate(['/artefato-layout-arquivo']);
    }

}



// WEBPACK FOOTER //
// ./src/app/artefato/cadastro-layout-arquivo/cadastro-layout-arquivo.component.ts